import {  
  getFirestore,
  doc,
  getDoc,
  where,
  collection,
  query,
  getDocs
} from "firebase/firestore";
import formatData from "../utils/formatData";
import formatProgramOnsiteData from "../utils/formatProgramOnsiteData";
import {
  onsiteConfig
} from '@/helpers/onsiteConfig'
const getProgramInfoById = async function(id, uid, onsite) {
  let db = getFirestore();

  let ref = doc(db, "wellness_program", id );
  const docSnapa = await getDoc(ref);

  //get onsite data
  let startDate = formatData('datepicker', new Date());
  let endDate = formatData('datepicker', new Date());
  let onsiteCount = 0;
  let memberOnsite = 2;
  let onsiteData = {};
  let surveyInfo = {};  
  if( onsite != undefined ){
  
    ref = doc(db, "wellness_program", id, "members", uid );
    let memberProgramDataRaw = (await getDoc(ref));
    
    if( memberProgramDataRaw.data() != undefined ){
      memberOnsite = memberProgramDataRaw.data().memberOnsite;
      // onsiteCount = Object.keys(memberProgramDataRaw.data()).reduce(function(r, e) {
      // if( e.startsWith('onsite') && e != 'onsiteCount') r += 1;
      //   return r;
      // }, 0);
  
      for( let i = 1; i <= memberOnsite; i++ ){
        ref = doc(db, "wellness_program", id, "members", uid, "onsite", "onsite" + i );
        let onsiteDataRaw = (await getDoc(ref));
        if( onsiteDataRaw.data() != undefined ){
          onsiteData['onsite' + i] = await formatProgramOnsiteData(onsiteDataRaw.data());
          onsiteCount = i;
        }
        else{
          i = 11;
        }
      }    
  
      if( memberProgramDataRaw.data().startDate != undefined ){
        startDate = formatData('datepicker', memberProgramDataRaw.data().startDate.toDate());
      }
      if( memberProgramDataRaw.data().endDate != undefined ){
        endDate = formatData('datepicker', memberProgramDataRaw.data().endDate.toDate());
      }
  
      onsiteData.target = memberProgramDataRaw.data()['target'];
      //survey
      for (const [key] of Object.entries(onsiteConfig['survey'])) {
          surveyInfo['pre' + key] = '-';
          if( memberProgramDataRaw.data()['pre' + key] != undefined ){
            surveyInfo['pre' + key] = memberProgramDataRaw.data()['pre' + key];
          }
    
          surveyInfo['post' + key] = '-';
          if( memberProgramDataRaw.data()['post' + key] != undefined ){
            surveyInfo['post' + key] = memberProgramDataRaw.data()['post' + key];
          }
      }
    }
  }
    
  //get member number
  let memberRef = collection(db, "wellness_users");
  const memberQuery = query( 
    memberRef,
      where("currentProgram", "==", id)
  );
  const docSnap = (await getDocs(memberQuery));

  return {
    ...docSnapa.data(), 
    ... { 
        members: docSnap.size, 
        onsite: onsiteData, 
        startDate: startDate, 
        endDate: endDate,
        target: onsiteData.target == undefined ? {} : onsiteData.target,
        survey: surveyInfo,
        onsiteCount: onsiteCount,
        memberOnsite: memberOnsite
    }
  };

};

export default getProgramInfoById;
